import * as React from 'react';
import cx from 'classnames';

import Logo from '../Logo';

import styles from './style.scss';

const SignupAlreadyRegisteredLogo = ({ className }: { className?: string }) => {
  return <Logo className={cx(styles.logo, className)} />;
};

export default SignupAlreadyRegisteredLogo;
